const template = `
<div class="uoe-container uoe-bottom">
  <div class="uoe-content">
    <h2 id="uoe-consent-desc" class="uoe-heading"></h2>
      <p>
        We use cookies to make this website work.
      </p>
      <p>
        We'd also like to set additional cookies to analyse how our sites are performing
        and to improve the relevance of our ads.
      </p>
      <div class="uoe-actions">
        <button type="button" class="uoe-btn uoe-btn-primary" data-consent-accept>Accept additional cookies</button>
        <button type="button" class="uoe-btn uoe-btn-primary" data-consent-reject>Reject additional cookies</button>
        <button type="button" class="uoe-btn uoe-btn-secondary" data-consent-settings>Cookie settings</button>
      </div>
    </div>
  </div>
</div>
`

export default template
